import { Box, Typography } from "@mui/material";
import { 
  // color, 
  styled } from "@mui/system";
import React from "react";
// import { FaPlus } from "react-icons/fa";
import StyledHeaderText from "../../../components/styles/StyledHeaderText";
import { useModal } from "../../../contexts/modalContext";
import { StyledButton } from "../../../pages/auth/Login";

const StyledCustomersHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
}));

const CustomersHeader = () => {
  const { toggleModal } = useModal();

  return (
    <StyledCustomersHeader>
      <StyledHeaderText variant="h1"> Rental Customers</StyledHeaderText>
      <StyledButton onClick={toggleModal.bind(this, "modal1")} sx={{ mr: 2 }}>
        <Typography variant="p">Add Customer</Typography>
      </StyledButton>
    </StyledCustomersHeader>
  );
};

export default CustomersHeader;
